module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "xiazai-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "xiazai-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "app-box-ewm"
  }, [_c('div', {
    staticClass: "app-box-ewm-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.guojianzhuoxiazai')))]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/anzhuo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div-content"
  }, [_c('span', {
    staticClass: "app-box-ewm-item-div-content-span"
  }, [_vm._v("GET IN ON")]), _vm._v(" "), _c('span', {
    staticClass: "app-box-ewm-item-div-content-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.anzhuoxiazai')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.guojipingguoxiazai')))]), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/pingguo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-box-ewm-item-div-content"
  }, [_c('span', {
    staticClass: "app-box-ewm-item-div-content-span"
  }, [_vm._v("Download on the")]), _vm._v(" "), _c('span', {
    staticClass: "app-box-ewm-item-div-content-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.pingguoxiazai')))])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-box-ewm-item-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/ewm.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-box-ewm-item-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/iosewm.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01619501"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiazai/xiazai.vue
// module id = 796
// module chunks = 1